export interface ApiError {
  type: string;
  request_id?: string;
  info?: {
    kind?: string;
    field?: string;
  };
}
